export default __webpack_public_path__ + "telegraph.4eaba090.png";